import { MissingLicenseRedirect, useIsOnboardingRoute, useIsProtectActive } from "@sg-protect/shell";
import { type PropsWithChildren } from "react";

export function SubscriptionBoundary({ children }: PropsWithChildren) {
    const isProtectActive = useIsProtectActive();
    const isOnboardingRoute = useIsOnboardingRoute();

    // The missing-license route itself is `isOnboardingStep: true`, so being on it already
    // satisfies isOnboardingRoute — no separate pathname check needed to avoid a redirect loop.
    if (!isProtectActive && !isOnboardingRoute) {
        return <MissingLicenseRedirect />;
    }

    return children;
}
